import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import ReactMultiSelectCheckboxes from "react-multiselect-checkboxes";
import "./style.css";

function MultiSelectCheckboxes(props) {
  const {
    className,
    name,
    value,
    placeholder,
    options,
    clearFilters,
    error,
    isDisabled,
    editPolygon,
  } = props;
  let placeholderValueCheck =
    editPolygon === true
      ? value.length + " selected"
      : "All " + placeholder + " Selected";
  const [state, changeState] = useState(value);
  const [placeholderText, changePlaceholder] = useState(placeholderValueCheck);

  useEffect(() => {
    let defaultState = {
      id: null,
      value: null,
      label: null,
    };
    function handleStatusChange() {
      changeState(defaultState);
    }
    async function fetchBookList() {
      await props.onChange({ name: props.name, value: defaultState });
    }
    if (clearFilters === true && value.label !== undefined) {
      fetchBookList();
      handleStatusChange();
    }
    if (props.error === true) {
      // $(".country-required > .css-yk16xz-control").attr(
      //   "style",
      //   "border: 1px red solid !important"
      // );
    }
  }, [clearFilters, value, props]);

  const handleChange = (state) => {
    if (state.length === 0) {
      let placeholderValueCheck =
        state.length === 0
          ? state.length + " selected"
          : "All " + placeholder + " Selected";
      changePlaceholder(placeholderValueCheck);
    }
    changeState(state);
    props.onChange({ name: name, value: state });
  };
  return (
    <ReactMultiSelectCheckboxes
      className={className}
      name={name}
      autoFocus={error}
      placeholderButtonLabel={placeholderText}
      onChange={handleChange}
      closeMenuOnSelect={false}
      // components={animatedComponents}
      defaultValue={state}
      isDisabled={isDisabled}
      isClearable
      isSearchable
      options={options}
    />
  );
}

function mapStateToProps(state) {
  const { clearFilters } = state.map;
  const { editPolygon } = state.drawing;
  return {
    clearFilters,
    editPolygon,
  };
}

const mapDispatchToProps = {};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(MultiSelectCheckboxes);
